import { sortCaseInsensitive } from '../../../common/util/sortCaseInsensitive';

/**
 * Manager acknowledgement base type required for sorting acknowledgements.
 */
export type AcknowledgementBase = {
  manager: {
    firmKey: string;
    firmName: string;
    firmNameAbbreviation?: string | null;
  };
};

export function sortAcknowledgements<TAcknowledgement extends AcknowledgementBase>(
  acknowledgements: readonly TAcknowledgement[] | null | undefined,
  oidcUserCmgEntityKey: string | null
) {
  return (
    acknowledgements?.slice().sort((a, b) => {
      if (a.manager.firmKey === oidcUserCmgEntityKey) {
        return -1;
      }
      if (b.manager.firmKey === oidcUserCmgEntityKey) {
        return 1;
      }

      return sortCaseInsensitive(
        a.manager.firmNameAbbreviation || a.manager.firmName,
        b.manager.firmNameAbbreviation || b.manager.firmName
      );
    }) ?? []
  );
}

type CanAcknowledgeAllocationProps = {
  canBndAgentUpdateInstitutionalIndication: boolean;
  canUserUpdateInstitutionalIndication: boolean;
  matchingCmgEntityKeys: readonly string[];
  bndAgentCmgEntityKey: string | null | undefined;
};

export const canAcknowledgeAllocation = ({
  canBndAgentUpdateInstitutionalIndication,
  canUserUpdateInstitutionalIndication,
  bndAgentCmgEntityKey,
  matchingCmgEntityKeys,
}: CanAcknowledgeAllocationProps) => {
  if (
    canBndAgentUpdateInstitutionalIndication &&
    !!bndAgentCmgEntityKey &&
    matchingCmgEntityKeys.includes(bndAgentCmgEntityKey)
  ) {
    return true;
  }

  return !canBndAgentUpdateInstitutionalIndication && canUserUpdateInstitutionalIndication;
};
